import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
//import {  Page1Service } from './page1.service'
import { UserService } from '../shared/user.service';
import { Page } from './page1.model';


@Component({
  selector: 'app-page1',
  templateUrl: './page1.component.html',
  styleUrls: ['./page1.component.css']
})
export class Page1Component implements OnInit {
  public pageData: Page = null;//{Name: 'PageName111'};

  constructor(private router: Router, private userService: UserService) { }

  ngOnInit() {
    // this.userService.getPageData().subscribe((data: Page) => {
    //   this.pageData = data;
 
    // });   
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/Pensioner/PensionerPnoCharger/PnoCharger/Client/src/app/page1/page1.component.ts